import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {KeycloakService} from 'keycloak-angular';
import {TokenStorageService} from '../services/storage/token-storage.service';
import {AuthService} from "../services/auth.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  isLoggedIn = false;


  constructor(
    private tokenStorageService: TokenStorageService,
    private router: Router,
    private authService: AuthService,
    private keycloakService: KeycloakService,
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean | UrlTree {
    let url: string = state.url;

    return this.checkLogin(url);
  }

  checkLogin(url: string): boolean | UrlTree {

    // Live Keycloak state (established by check-sso at app init) is the
    // authoritative signal; the stored token keeps the legacy backend-login
    // flow working. After a Keycloak logout both are gone.
    this.isLoggedIn =
      this.keycloakService.isLoggedIn() ||
      !!this.tokenStorageService.getToken();
    const isInitialLogin = this.tokenStorageService.getUser()?.initialLoginFlag === 1;

    if (isInitialLogin) {
      if (url.includes('/login/change-password')) {
        return true;
      }
      return this.router.parseUrl('/login/change-password');
    } else if (this.isLoggedIn) {
      return true;
    } else {
      if (url.includes('/registration') || url.includes('/password-reset')) {
        return true;
      }
      return this.router.parseUrl('/');
    }
  }
}
